<template>
    <button class="submit-button"
            @click.prevent="$emit('click')">
        <div class="submit-button__body">
            <transition name="fade">
                <img class="submit-button__sending"
                     v-if="sending"
                     src="../icons/loaders_icon.gif">
            </transition>

            <span class="submit-button__title"
                  :class="{'_hide': sending}">
                <slot>
                    {{ $t('common.submit') }}
                </slot>
            </span>
        </div>
    </button>
</template>

<script>
    export default {
        name: 'SubmitButton',
        props: {
            sending: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="less">
    @import (less) '../styles/colors.less';

    .submit-button {
        padding: 5px 10px;
        border: none;
        border-radius: 0;
        transition: background .3s ease-out;
        height: 40px;
        text-transform: uppercase;
        color: white;
        font-size: 13px;
        font-weight: bold;
        letter-spacing: 1.3px;
        cursor: pointer;

        .land-rover-style & {
            background: @landRoverBlack;
        }

        .jaguar-style & {
            background: @jaguarBright;
        }

        &:hover {
            color: white;

            .land-rover-style & {
                background: @landRoverBlack !important;
            }

            .jaguar-style & {
                background: @jaguarBright !important;
            }
        }

        &:focus {
            outline: none;
        }

        &__body {
            position: relative;
        }

        &__title {
            transition: opacity .4s;

            &._hide {
                opacity: 0;
            }

            .jaguar-style &::after {
                content: '';
                display: inline-block;
                width: 10px;
                height: 12px;
                position: relative;
                top: 2px;
                background: url(../icons/button_arrow.svg) no-repeat;
                background-size: 7px;
            }
        }

        &__sending {
            position: absolute;
            top: -22px;
            left: 50%;
            transform: translateX(-50%);
            height: 60px;
            width: 80px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/SubmitButton.vue